import * as Effects from 'redux-saga/effects';

export const call: any = Effects.call;
export const all: any = Effects.all;
export const takeEvery: any = Effects.takeEvery;
export const put: any = Effects.put;
export const select: any = Effects.select;
export const takeLatest: any = Effects.takeLatest;
